function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "translate(-32247 -1893)",
  d: "M32250.9,1893h0.7c-0.4,0.8-0.7,1.3-0.8,1.6     c-0.2,0.3-0.5,0.8-1,1.4h15.2v1h-15.2c0.7,0.7,1.3,1.7,1.9,3h-0.7c-0.8-0.9-1.5-1.6-2.1-2.1c-0.6-0.5-1.2-0.9-1.8-1.2v-0.4     c0.6-0.2,1.1-0.6,1.8-1.1C32249.4,1894.6,32250.1,1893.9,32250.9,1893z"
});

function SvgIconLeftPointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-left-pointer",
    viewBox: "0 0 18 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftPointer);
export default __webpack_public_path__ + "static/media/icon-left-pointer.59a4f3c6.svg";
export { ForwardRef as ReactComponent };